export default __webpack_public_path__ + "static/media/22-HeartOfVenice.20170516.jpeg";